<template>
<div>
    OLD!
    <div class="row">
        <div class="col-md-12 ">
            <ExtentList @checkChange="handleCheckChangeParent" />
        </div>
    </div>
    <el-button type="primary" @click="add_blank_rule()">Add a Rule</el-button>
    <el-button type="info" @click="run_ruleset()">Run this ruleset</el-button>
    <el-button type="info" v-on:click="example">Add example rule</el-button>
    <el-button type="info" v-on:click="go_simple">Simple rules</el-button>
    <el-dialog
            :title="editing_label"
            :visible.sync="editing_cell_modal">
        <div>{{editing_instructions}}</div>
        <el-input @keyup.enter.native="cell_change" placeholder="new value" v-model="cell_input" autofocus="true"></el-input>
        <el-button  @click="cell_change()">Save</el-button>
        <el-button  @click="unselect_current_cell()">Cancel</el-button>
    </el-dialog>
    <el-dialog
        title="Add Field to Rules"
        :visible.sync="show_new_field_overlay">

        <h4>Existing fields, not yet used in any rules</h4>
        <el-select filterable v-model="selected_new_field" placeholder="Select field">

            <el-option
                    v-for="item in available_fields"
                    :key = "item.id"
                    :label = "item.display_name"
                    :value = "item.display_name">
            </el-option>
        </el-select>
        <el-button  @click="add_field()">Add</el-button>
        <h4>Import and merge new data with other fields</h4>
        <el-button>Import</el-button>

    </el-dialog>

    <el-table
            :data="array_data"
            style="width: 100%">
            <el-table-column
                v-for = "column in columns"
                v-bind:label = column.label
                sortable
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.rule_id === active_edit_cell.rule_id && column.label === active_edit_cell.header_name && column.label.toLowerCase() === 'order'">
                            <el-input v-on:keyup.enter="cell_change()" placeholder="new order" v-model="cell_input"></el-input>
                            <el-button  @click="move_row(scope.row.rule_id)">Save</el-button>
                            <el-button  @click="unselect_current_cell()">Cancel</el-button>
                    </div>
                    <div v-else>
                        <span v-if="column.label.toLowerCase() === 'rule_id'">
                            <el-button round @click="delete_row(scope.row.rule_id)" icon="el-icon-delete">{{ scope.row[column.label] }}</el-button>
                        </span>
                        <span v-else-if="column.label.toLowerCase() === 'add field'">
                            <el-button round icon="el-icon-circle-plus-outline" @click="show_new_field_overlay = true"></el-button>
                        </span>
                        <span v-else-if="column.label.toLowerCase() === 'order'">
                            <el-button @click="setEditableInplace(scope.row.rule_id, column.label,scope.row[column.label])">{{ scope.row[column.label] }}</el-button>
                        </span>
                        <el-button v-else  @click="setEditableModal(scope.row.rule_id, column.label,scope.row[column.label])">{{ scope.row[column.label] }}</el-button>
                    </div>

                </template>
            </el-table-column>
    </el-table>
</div>
</template>

<script>
//    import component2 from './component2.vue'
    export default {
        props: ['ruleset_id','extent_id'],
        mounted() {
            // console.log('Component mounted now.')
            this.getDispositions()
        },
        watch: {
            extent_id: function (newValue, oldValue) {
                this.load_ruleset_after_extent_change()
            },
            ruleset_id: function (newValue, oldValue) {
                this.trigger_flatten()
            }
        },
        computed: {
            editing_label: function () {
                let label = "value"
                if (this.active_edit_cell.header_name == "disposition") {
                    label = "value";
                } else if (this.active_edit_cell.header_name == "order"
                    || this.active_edit_cell.header_name == "rule_id"
                    || this.active_edit_cell.header_name == "name"
                    || this.active_edit_cell.header_name == "bucket"
                    || this.active_edit_cell.header_name == "resourcing") {
                    label = "value";
                } else {
                    label = "rule"
                }
                return "Edit " + label + " for " + this.active_edit_cell.header_name
            },
            editing_instructions: function () {
                if (this.active_edit_cell.header_name == "disposition") {
                    return "Consider using one of these standard dispositions: " + this.dispositions_list;
                } else if (this.active_edit_cell.header_name == "order"
                    || this.active_edit_cell.header_name == "rule_id"
                    || this.active_edit_cell.header_name == "name"
                    || this.active_edit_cell.header_name == "bucket"
                    || this.active_edit_cell.header_name == "resourcing") {
                    return "";
                } else {
                    return "The first character must be an operator to compare the value of this field to the rule. Valid operators are: =, <, >, and ∅ (to indicate field must be empty). Advanced operator is / (to indicate the start of a regular expression)";
                }
            },
            dispositions_list: function () {
                let list = ""
                let first = true
                this.dispositions.forEach((disposition,index) => {
                    if (first) first = false
                    else list = list + ", "
                    list = list + disposition.slug
                })
                return list
            }
        },
        data() {
            return {
                counter: 0,
                columns: [{prop: 'rule_id', label:'Rule ID', width: 180},{prop: 'name', label: 'Name', width: 180}],
                array_data:[],
                active_edit_cell: {rule_id: null, header_name: null, new_value: null},
                cell_input: '',
                editing_cell_modal: false,
                editing_cell_inplace: false,
                available_fields: '',
                selected_new_field: '',
                show_new_field_overlay: false,
        }},
        components: {},
        methods: {
            trigger_flatten() {
                axios.post('/api/flattened/trigger/' + this.ruleset_id)
                    .then(response => {
                        // console.log("just completed flattening")
                        this.load_data()
                        axios.get('/api/flattened/' + this.ruleset_id + '/columns/available')
                            .then(response => {
                                this.available_fields = response.data
                                // console.log(this.array_data)
                            })
                            .catch(error => {
                                console.log('oops table data')
                            })
                    })
                    .catch(error => {
                        console.log('oops flattening')
                    })
            },
            add_blank_rule() {
                axios.post('/api/flattened/' + this.ruleset_id + '/add_blank_rule', {
                }).then(response => {
                    // console.log('added a blank rule in the backend successfully')
                    // console.log(response)
                    this.load_data()
                })
            },
            example() {
                axios.post('/api/flattened/example', {
                    ruleset_id: this.ruleset_id
                }).then(response => {
                        // console.log(response)
                        this.load_data()
                })
            },
            load_data() {
                axios.get('/api/flattened/json/' + this.ruleset_id)
                    .then(response => {
                        this.array_data = response.data
                        // console.log(this.array_data)
                    })
                    .catch(error => {
                        console.log('oops table data')
                    })
                axios.get('/api/flattened/json/' + this.ruleset_id + '/columns')
                    .then(response => {
                        var new_column
                        this.columns = response.data
                        new_column = {"label":"add field"}
                        this.columns.push(new_column)
                        // console.log(this.columns)
                    })
                    .catch(error => {
                        console.log('oops table columns')
                    })
            },
            listener() {
                // console.log('listen')
            },
            setEditableModal(rule_id, header_name, current_value) {
                this.cell_input = current_value
                this.active_edit_cell.rule_id = rule_id
                this.active_edit_cell.header_name = header_name
                this.editing_cell_modal = true
            },
            setEditableInplace(rule_id, header_name, current_value) {
                this.cell_input = current_value
                this.active_edit_cell.rule_id = rule_id
                this.active_edit_cell.header_name = header_name
                this.editing_cell_inplace = true
            },
            delete_row(rule_id) {
                // console.log(this.ruleset_id)
                // console.log(rule_id)
                axios.delete('/api/flattened/' + this.ruleset_id + '/' + rule_id, {
                }).then(response => {
                    // console.log(response)
                    this.load_data()
                })
            },
            add_field() {
                // console.log("about to add a field")
                axios.post('/api/flattened/' + this.ruleset_id + '/columns',  {
                    new_column: this.selected_new_field
                }).then(response => {
                    // console.log(response)
                    this.load_data()
                    this.show_new_field_overlay = false
                })
            },
            run_ruleset() {
                axios.post('/api/jobChains', {
                    flattened_id: this.ruleset_id,
                    type: "assign"
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops starting job chain')
                    console.log(response)
                })
            },
            move_row(rule_id) {
                axios.patch('/api/flattened/' + this.ruleset_id + '/' + rule_id, {
                    new_position: this.cell_input
                }).then(response => {
                    // console.log('successfully moved row')
                    // console.log(response)
                    this.unselect_current_cell()
                    this.load_data()
                }).catch(error => {
                    console.log('oops row move problem')
                    console.log(response)
                    })
            },
            unselect_current_cell() {
                this.active_edit_cell.rule_id = null
                this.active_edit_cell.header_name = null
                this.cell_input = null
                this.editing_cell_modal = false
                this.editing_cell_inplace = false
            },
            cell_change() {
                // console.log("in cell_change()")
                if (this.header_name == 'order') {
                    // change order
                    // console.log("about to change the order")
                } else {
                    // change cell value
                    // console.log("changing something other than the order")
                    axios.patch('/api/flattened/' + this.ruleset_id + '/' + this.active_edit_cell.rule_id + '/' + this.active_edit_cell.header_name, {
                        new_value: this.cell_input
                    }).then(response => {
                        this.load_data()
                        this.unselect_current_cell()
                        // console.log(response)
                    })
                }
                this.editing_cell_modal = false
                this.editing_cell_inplace = false
            },
            load_ruleset_after_extent_change() {
                axios.get('/extents/ruleset/' + this.extent_id)
                    .then(response => {
                        if (response.data.id) {
                            this.ruleset_id = response.data.id
                            this.load_data()
                            axios.get('/api/flattened/' + this.ruleset_id + '/columns/available')
                                .then(response => {
                                    this.available_fields = response.data
                                    // console.log(this.array_data)
                                })
                                .catch(error => {
                                    console.log('oops getting columns available data')
                                })
                        }
                    })
                    .catch(error => {
                        console.log('oops problem changing extent')
                    })
            },
            handleCheckChangeParent(selected_extent) {
                this.extent_id = selected_extent.id
                this.load_ruleset_after_extent_change()
            },
            getDispositions() {
                axios.get('/api/CE/dispositions')
                    .then(response => {
                        // console.log("dispositions")
                        this.dispositions = response.data
                        // console.log(this.dispositions)
                    })
                    .catch(error => {
                        console.log('oops problem getting dispositions')
                    })
            },
            go_simple() {
                window.location.href = "/simplerules/"
            }
        }
    }
</script>
